<template>
  <div class="safe companyInfo">
    <el-form :rules="uploadRules" :model="ruleForm" ref="ruleForm">
      <span class="text">{{ aptitudeName }}</span>
      <el-form-item>
        <el-input
          v-show="false"
          maxlength="100"
          v-model="ruleForm.id"
          class="input-short"
          placeholder="默认带来的的id"
        />
      </el-form-item>
      <el-form-item label="发证机关网址：" prop="website" class="website">
        <el-input
          maxlength="100"
          v-model.trim="ruleForm.website"
          class="input-short"
          placeholder="请输入发证机关网址"
        />
      </el-form-item>
      <div class="block">
        <el-form-item
          label="有效期："
          prop="validityStart"
          style="padding-left: 48px"
        >
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.validityStart"
            type="date"
            placeholder="开始时间"
            :picker-options="{
              disabledDate: (time) => {
                if (this.ruleForm.validityEnd) {
                  return (
                    time.getTime() >
                    new Date(this.ruleForm.validityEnd).getTime() - 86400000
                  );
                }
                return time.getTime() > Date.now();
              },
            }"
          ></el-date-picker
          >&nbsp;-&nbsp;
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.validityEnd"
            :disabled="ruleForm.isLongValidity"
            type="date"
            placeholder="结束时间"
            :picker-options="{
              disabledDate: (time) => {
                if (this.ruleForm.validityStart) {
                  return (
                    time.getTime() <
                    new Date(this.ruleForm.validityStart).getTime()
                  );
                }
              },
            }"
          ></el-date-picker>
          <el-checkbox
            v-model="ruleForm.isLongValidity"
            class="checkBox"
            @change="dateEndChange()"
            >长期</el-checkbox
          >
        </el-form-item>
      </div>

      <el-form-item
        class="scanFile3"
        label="扫描件："
        prop="scanFile3"
        style="padding-left: 64px"
      >
        <div style="height: 86px" class="mustCheck">
          <el-file-upload
            ref="upload"
            v-model="ruleForm.scanFile3"
            :on-change="changeFile"
            :on-success="handleSuccess"
            :on-error="fileError"
            :on-delete="onFileDelete"
            :file-list="fileList"
            :auto-upload="true"
            :limit="1"
            :action="importFileUrl"
            file-ref="fileRef2"
            :handlePictureCardPreview="handlePictureCardPreview"
            :before-upload="beforeAvatarUpload"
          ></el-file-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "uploader",
  props: {
    aptitudeName: String,
    uploaderId: Number,
    uploaderDataCom: Object,
  },
  data() {
    return {
      ruleForm: {
        isLongValidity: null,
        validityEnd: null,
        validityStart: null,
        website: "",
      },
      uploaderData: [
        {
          aptitudeCode: "",
          aptitudeName: "",
          id: "",
        },
      ],
      dialogVisible: false,
      dialogImageUrl: "",
      percentage: "100",
      disabled: false,
      isLongValidity: false,
      validityEnd: "",
      validityStart: "",
      fileName: "",
      website: "",
      // 批文附件上传
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址
      fileList: [],
      fileListData: [],
      uploadId: "",
      fileType: "",
      uploadRules: {
        fileName: [
          {
            required: true,
            // pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
            message: "请输入正确的资质名称",
            trigger: ["blur"],
          },
        ],
        // scanFile3: [
        //   {
        //     required: true,
        //     message: "请上传公司资质",
        //     trigger: "blur",
        //   },
        // ],
        uploaderValid: false,
      },
    };
  },

  created() {
    console.log("uploaderData", this.uploaderData);
    this.ruleForm.id = this.uploaderId;
    console.log(this.ruleForm.id);
    console.log("fileList", this.fileList);
  },
  methods: {
    dateEndChange() {
      this.ruleForm.validityEnd = null;
    },
    //验证的方法
    validateUploader() {
      this.$refs.ruleForm.validate((valid) => {
        this.$emit("isUploaderValid", valid);
      });
    },
    //附件信息上传之前的钩子
    beforeAvatarUpload(file) {
      let fileNameBefore = file.name;
      let pos = fileNameBefore.lastIndexOf(".");
      let lastName = fileNameBefore.split(".").pop().toLowerCase();
      console.log(lastName);
      if (
        lastName === "jpg" ||
        lastName === "png" ||
        lastName === "jpeg" ||
        lastName === "gif" ||
        lastName === "xls" ||
        lastName === "xlsx" ||
        lastName === "doc" ||
        lastName === "docx" ||
        lastName === "pdf"
      ) {
      } else {
        // console.log(lastName !== 'jpg' )
        this.$message({
          message:
            "上传文件支持格式：.jpg .png .jpeg .gif 每个不超过5M，.xls .xlsx .doc .docx .pdf每个不超过15M",
          type: "error",
          offset: this.messageHeight,
        });
        return false;
      }
      // console.log("fileList2:", file);
      const isJPG = file.type === "image/jpeg";
      const isPDF = file.type === "application/pdf";
      const isGIF = file.type === "image/gif";
      const isLt5M = file.size / 1024 / 1024 < 5;
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (isJPG || isGIF) {
        if (!isLt5M) {
          this.$message({
            message: "上传图片大小不能超过 5MB!",
            type: "error",
            offset: this.messageHeight,
          });
          return false;
        }
      } else {
        if (!isLt15M) {
          this.$message({
            message: "上传文件大小不能超过 15MB!",
            type: "error",
            offset: this.messageHeight,
          });
          return false;
        }
      }
      return true;
    },
    // 附件信息上传
    changeFile(file, fileList) {
      console.log("fileList:", fileList);
      this.fileList = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },
    // 删除附件信息
    onFileDelete(file) {
      this.fileList.splice(file, 1);
    },
    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      console.log(response.data[0]);
      this.fileType = response.data[0].fileType;
      this.uploadId = response.data[0].uploadId;
      this.fileName = this.uploaderData.aptitudeName;
      // this.fileType = 10;
    },
    // 点击已上传附件信息的时触发
    handlePictureCardPreview(file, fileList) {
      console.log("uploseerFile", file, fileList);
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message.warning("该文件类型不支持预览");
      } else {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },
    //附件上传失败的钩子
    fileError(response, file, fileList) {
      console.log();
      this.fileList = [];
      this.$message.warning(`文件上传失败，请重新上传`);
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.remarkItem {
  position: relative;
  span {
    position: absolute;
    right: -280px;
    width: 266px;
  }
}
.perfectingInformation {
  margin: 0 auto;
  .detailedInformation {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    padding-bottom: 26px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 23%;
    .el-card-title {
      /deep/ .details-title {
        color: rgba(255, 20, 47, 1);
        border-bottom: 2px solid rgba(255, 20, 47, 1);
        margin-left: 20px;
      }
    }
    .el-form {
      .el-form-item {
        margin: 20px 0 0 80px;
        // color: rgba(208, 2, 27, 1);

        .format {
          font-size: 13px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: rgba(155, 155, 155, 1);
          line-height: 17px;
        }
        /deep/ .el-form-item__label {
          padding: 1px 2px 0 0;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
        }
        /deep/ .el-form-item__content {
          .input-long {
            width: 430px;
          }
          .input-short {
            width: 430px;
          }
          .el-input__inner {
            width: 430px;
          }
          .textarea-long {
            width: 100%;
            height: 66px;
            .el-textarea__inner {
              width: 430px;
              height: 66px !important;
              border: 1px solid rgba(204, 204, 204, 1);
              background: #f5f5f5;
              padding-left: 10px;
              color: rgba(74, 74, 74, 1);
              font-family: PingFangSC-Regular, PingFangSC;
              font-weight: 400;
              // color: rgba(155, 155, 155, 1);
              line-height: 17px;
            }
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: center;
    .left-btn {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      margin-right: 20px;
      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
    .right-btn {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
  }
}

.nameTip,
.codeTip1,
.codeTip2 {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 15px;
}
.el-radio:nth-child(2) {
  margin-left: 30px;
}
.footer .btn {
  background-color: rgba(255, 20, 47, 1);
  border-color: rgba(255, 20, 47, 1);
}

.uploadInfo {
  padding-top: 17px;
  position: relative;
}
.safe {
  margin-bottom: 16px;
}
.safe .text {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 48px;
}
.licenseWebsite {
  margin-left: 56px;
}
.demonstration {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 119px;
}
.block {
  margin-top: 20px;
  padding-left: 16px;
}
.el-date-editor .el-input__inner {
  padding: 0 10px !important;
}
.el-date-editor--date {
  width: 140px;
  height: 30px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}

/deep/.checkBox {
  margin-left: 28px;
  /deep/.el-checkbox__label {
    position: relative;
    top: 1px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar-uploader {
  width: 80px;
  height: 80px;
  padding-bottom: 24px;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.commonTxt {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 6px;
  margin-top: 10px;
}
.commonTxt a {
  color: rgba(0, 137, 239, 1);
  cursor: pointer;
}
.lastYearTurnoverTxt {
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
.addBox {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 20, 47, 1);
  line-height: 18px;
  margin-left: 202px !important;
  cursor: pointer;
}
.intelligence {
  margin-left: 94px;
}
.companyInfoTxt {
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
.el-card-title {
  margin-top: 20px;
}
.website {
  margin: 20px 0 0 54px !important;
}
.el-form-item {
  padding-left: 50px;
}
.scanFile3 {
  padding-left: 58px;
}
/deep/.el-input__inner {
  padding: 0 10px !important;
}
/deep/.el-form-item__error {
  left: 76px;
}
/deep/ .mustCheck::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: -10px;
  top: 2px;
  font-size: 14px;
}
</style>
<style>
.el-radio__input.is-checked .el-radio__inner {
  background-color: rgba(59, 136, 253, 1);
  border-color: rgba(59, 136, 253, 1);
}
.el-radio__input.is-checked + .el-radio__label {
  color: rgba(74, 74, 74, 1);
}
.el-radio__inner:hover {
  border: 1px solid rgba(59, 136, 253, 1);
}
.el-radio__label {
  width: 65px;
  height: 17px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 17px;
}
.el-select-dropdown__item span {
  padding-left: 9px;
}

.el-upload--picture-card {
  width: 80px;
  height: 80px;
  padding-bottom: 24px;
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.el-input__inner,
.el-select,
.el-cascader {
  width: 430px;
}
.selectDate input {
  padding: 0 26px !important;
}
.el-file-upload .file .file-list li {
  margin: 0;
}
</style>
